import Vue from 'vue';
import i18next from 'i18next';
import VueI18Next from '@panter/vue-i18next'
import Backend from 'i18next-http-backend';

Vue.use(VueI18Next);

i18next
    .use(Backend)
    .init({
      lng: 'en',
      fallbackLng: 'de',
      whitelist: ['en', 'de']
    })

export const i18n = new VueI18Next(i18next);
